import constants from '../constants';

export default function initializeConstants(Vue) {
  if (Vue.prototype.$constants) return false;
  Object.defineProperty(Vue.prototype, '$constants', { value: constants });
  return Vue.prototype.$constants;
}